import ApiInstance from "./ApiInstance.js";

export default {
  getBasicData() {
    return ApiInstance({ requiresAuth: false }).get("/index");
  },
  getSingleCourse(country, city, uni_name, level, slug,uni_id,id) {
    return ApiInstance({ requiresAuth: false }).get(
      `/get-course/${country}/${city}/${uni_name}/${level}/${slug}/${uni_id}/${id}`
    );
  },
  getSingleUniversity(uni_id) {
    return ApiInstance({ requiresAuth: false }).get(
      `/get-university/${uni_id}`
    );
  },
  getForm(form_id) {
    return ApiInstance({ requiresAuth: false }).get(
      `/get-form/${form_id}`
    );
  },
  getUniCourse(uni_name) {
    return ApiInstance({ requiresAuth: false }).get(`/get-course/${uni_name}`);
  },
  getUniCampusCourse(uni_name, campus_name) {
    return ApiInstance({ requiresAuth: false }).get(
      `/get-course/${uni_name}/${campus_name}`
    );
  },
  getDisciplineCourse(discipline_name,id) {
    return ApiInstance({ requiresAuth: false }).get(
      `/get-discipline-course/${discipline_name}/${id}`
    );
  },
  getUniversitesWithListings() {
    return ApiInstance({ requiresAuth: false }).get(
      `/get-universties-with-listings`
    );
  },
  getUniversitesWithListingsByCity(city) {
    return ApiInstance({ requiresAuth: false }).get(`/get-universties/${city}`);
  },
  getEnrolledUniversites() {
    return ApiInstance({ requiresAuth: true }).get(`/get-enrolled-universites`);
  },
  getCountries() {
    return ApiInstance({ requiresAuth: false }).get("/countries");
  },
  getCountryWithCities(id) {
    return ApiInstance({ requiresAuth: false }).get(
      `/country-with-cities/${id}`
    );
  },
  getCities() {
    return ApiInstance({ requiresAuth: false }).get("/cities");
  },
  getDisciplines() {
    return ApiInstance({ requiresAuth: false }).get("/disciplines");
  },
  getLevels() {
    return ApiInstance({ requiresAuth: false }).get("/levels");
  },
  searchCourses(
    page_num,
    search_text,
    cities_data,
    universties_data,
    disciplines,
    levels
  ) {
    return ApiInstance({ requiresAuth: false }).post("/search-courses", {
      page_num: page_num,
      course: search_text,
      cities: cities_data,
      universties: universties_data,
      disciplines,
      levels,
    });
  },
  contactMyUni(fname, lname, email, subject, message, sendToEmail) {
    return ApiInstance({ requiresAuth: false }).post("/contact-form", {
      fname: fname,
      lname: lname,
      email: email,
      subject: subject,
      message: message,
      sendToEmail: sendToEmail,
    });
  },
  forgotPassword(email) {
    return ApiInstance({ requiresAuth: false }).post("/forgot-password", {
      email: email,
    });
  },
  ResetPassword(token, email, password, cpassword) {
    return ApiInstance({ requiresAuth: false }).post("/update-password", {
      token: token,
      email: email,
      password: password,
      cpassword: cpassword,
    });
  },
};
